import { type Enum } from '@webapp/utils'

export const BudgetCategoryTypes = {
  ALL: '',
  INCLUDE_SOURCE_OF_TRUTH: 'True',
  EXCLUDE_SOURCE_OF_TRUTH: 'False',
} as const

export type BudgetCategoryType = Enum<typeof BudgetCategoryTypes>
